import { useTranslation } from "react-i18next";
import { FlexWrapper } from "../../../../style/FlexWrapper";
import SubjectContactsForm, { validateSubjectContactsForm } from "../Forms/SubjectContactsForm";
import {
  useAddPolicySubjectContext,
  useAddPolicySubjectDispatch,
} from "./AddPolicySubjectContext";
import { Contacts } from "../../../../redux/apiSpecifications/apiSubjects";
import { ButtonCancel, ButtonConfirm } from "../../../Layout/Buttons";

interface IContactsStepProps {
  onNextStep: () => void;
  onPreviousStep: () => void;
}

const ContactsStep = ({ onNextStep, onPreviousStep }: IContactsStepProps) => {
  const { t } = useTranslation();

  const dispatch = useAddPolicySubjectDispatch();

  const { addPolicySubjectData } = useAddPolicySubjectContext();

  const handleOnChange = (subjectContacts: Contacts) => {
    dispatch!({
      type: "CHANGE_POLICY_SUBJECT_DATA",
      payload: {
        value: subjectContacts,
        field: "contacts",
      },
    });
  };

  const enableNextButton = validateSubjectContactsForm(
    addPolicySubjectData?.contacts
  );

  return (
    <FlexWrapper flexDirection="column" gap="2em">
      <SubjectContactsForm
        subjectContacts={addPolicySubjectData?.contacts}
        onChange={handleOnChange}
      />

      <FlexWrapper gap="1em" justifyContent="flex-end">
        <ButtonCancel onClick={onPreviousStep}>
          {t("BUTTONS.previous")!}
        </ButtonCancel>

        <ButtonConfirm onClick={onNextStep} disabled={!enableNextButton}>
          {t("BUTTONS.next")!}
        </ButtonConfirm>
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default ContactsStep;
